<script setup lang="ts">
import EventCheckpointAutocomplete from '@/components/Filters/EventCheckpointAutocomplete.vue'
import type { LocalStorageFilter } from '@/types/filters/DeviceFilters'
import { type TableDeviceModel } from '@/types/hooks/UseTableModelTypes'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { EventModel } from '@/types/models/EventModel'
import { StackLayout } from '@rfc/rfc-components-library'
import { ELocalStorage } from '@rfc/rfc-components-library/types'
import { getItemFromStorage } from '@rfc/rfc-components-library/utils'
import { ref } from 'vue'

type Props = TableDeviceModel
const props = defineProps<Props>()

const storedEvent = ref(getItemFromStorage<LocalStorageFilter>(ELocalStorage.FILTERS)?.event)
const storedCheckpoint = ref<CheckpointModel>()

const handleChangeEvent = (value?: EventModel) => {
    storedEvent.value = value
    storedCheckpoint.value = undefined
    props.handleChangeFilters({ event_id: value?.id, checkpoint_id: undefined })
}

const handleChangeCheckpoint = (value?: CheckpointModel) => {
    storedCheckpoint.value = value
    props.handleChangeFilters({ checkpoint_id: value?.id })
}
</script>

<template>
    <StackLayout :gap="8" isResponsiveSmallScreen class="w-full">
        <EventCheckpointAutocomplete
            :event="storedEvent"
            :checkpoint="storedCheckpoint"
            keepEventInStorage
            @selectEvent="handleChangeEvent($event)"
            @selectCheckpoint="handleChangeCheckpoint($event)" />
    </StackLayout>
</template>
